"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Row = _interopRequireDefault(require("../../layout/Row"));

var _units = require("../../theme/units");

var _BaseInput = _interopRequireDefault(require("../BaseInput"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var WrappingLabel = (0, _styledComponents["default"])(_Row["default"]).withConfig({
  displayName: "RadioButton__WrappingLabel",
  componentId: "sc-1369ncb-0"
})(function (props) {
  return (0, _styledComponents.css)(["min-height:3rem;span{padding-top:0.25rem;padding-bottom:0.75rem;}", ":hover{", "{box-shadow:0 0 0 2px ", ";}}"], props.disabled ? (0, _styledComponents.css)(["pointer-events:none;"]) : (0, _styledComponents.css)(["cursor:pointer;"]), HitBox, props.theme.color.hover);
});

var RadioContainer = _styledComponents["default"].div.withConfig({
  displayName: "RadioButton__RadioContainer",
  componentId: "sc-1369ncb-1"
})(["margin-bottom:auto;position:relative;flex-grow:0;"]);

var HiddenInput = (0, _styledComponents["default"])(_BaseInput["default"]).withConfig({
  displayName: "RadioButton__HiddenInput",
  componentId: "sc-1369ncb-2"
})(function (props) {
  return (0, _styledComponents.css)(["position:absolute;height:1px;width:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;:focus + ", "{background:", ";> ", "{background:", ";}}"], StyledRadio, props.theme.color.focus, RadioControl, props.theme.color.focus);
});

var StyledRadio = _styledComponents["default"].div.withConfig({
  displayName: "RadioButton__StyledRadio",
  componentId: "sc-1369ncb-3"
})(["display:inline-block;width:40px;height:40px;padding:2px;border-radius:50%;"]);

var RadioControl = _styledComponents["default"].div.withConfig({
  displayName: "RadioButton__RadioControl",
  componentId: "sc-1369ncb-4"
})(function (props) {
  return (0, _styledComponents.css)(["width:36px;height:36px;padding:4px;border-radius:50%;border:2px solid ", ";background:", ";"], props.disabled ? props.theme.color.disabled : props.theme.color.action, props.disabled ? props.theme.pattern.disabled : props.theme.pattern.graphPaper);
});

var HitBox = _styledComponents["default"].div.withConfig({
  displayName: "RadioButton__HitBox",
  componentId: "sc-1369ncb-5"
})(function (props) {
  return (0, _styledComponents.css)(["display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;padding:0;border-radius:inherit;background:", ";box-shadow:0 0 0 2px transparent;", ""], props.theme.color.paper, props.checked && (0, _styledComponents.css)(["", "{transform:scale(1);}", ""], Blob, props.disabled && (0, _styledComponents.css)(["box-shadow:0 0 0 2px ", ";"], props.theme.color.paper)));
});

var Blob = _styledComponents["default"].div.withConfig({
  displayName: "RadioButton__Blob",
  componentId: "sc-1369ncb-6"
})(function (props) {
  return (0, _styledComponents.css)(["transition:transform 150ms ease;background:", ";width:100%;height:100%;border-radius:50%;transform:scale(0);"], props.disabled ? props.theme.color.structure : props.theme.color.action);
});

var LabelText = _styledComponents["default"].span.withConfig({
  displayName: "RadioButton__LabelText",
  componentId: "sc-1369ncb-7"
})(["flex-grow:999;"]);
/**
 *
 * ### Styled 'radio' type input component

The `RadioButton` component is generally used for displaying an option within a group of available options. For that reason, it is rarely, if ever, used on its own. Therefore it is recommended to only be used inside of the `RadioButtonGroup` container component as this will provide context to each `RadioButton`. Each `RadioButton` should be passed the props `label`, `value`, `id`, and optionally `disabled`. The rest of the props are handled by the `RadioButtonGroup` component.

### Importing
`import RadioButton from '@blueprism/ui-core/components/RadioButton';`
 */


var RadioButton = function RadioButton(_ref) {
  var id = _ref.id,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      value = _ref.value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? _units.formAlign.left : _ref$align,
      _ref$displayType = _ref.displayType,
      displayType = _ref$displayType === void 0 ? _units.formDisplayType["default"] : _ref$displayType,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      rest = _objectWithoutProperties(_ref, ["id", "name", "value", "label", "checked", "disabled", "align", "displayType", "onChange"]);

  return /*#__PURE__*/_react["default"].createElement(WrappingLabel, {
    element: "label",
    gap: "small",
    align: "center",
    reverse: align === 'right',
    justify: displayType === 'justified' ? 'between' : 'start',
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(RadioContainer, null, /*#__PURE__*/_react["default"].createElement(HiddenInput, _extends({
    type: "radio",
    id: id,
    name: name,
    value: value,
    checked: checked,
    disabled: disabled,
    onChange: onChange
  }, rest)), /*#__PURE__*/_react["default"].createElement(StyledRadio, {
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(RadioControl, {
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(HitBox, {
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(Blob, {
    disabled: disabled
  }))))), /*#__PURE__*/_react["default"].createElement(LabelText, null, label));
};

var _default = RadioButton;
exports["default"] = _default;